import React from "react";
import Latest from "./Latest";
import PNav from "./PNav";
import "./Projects.css";
import { motion } from "framer-motion";
import AllProjects from "./AllProjects";

const Projects = () => {
  const container = {
    first: { opacity: 0, scale: 1.5 },
    then: { opacity: 1, scale: 1, transition: { duration: 0.7 } },
    last: { opacity: 0, scale: 1.5, transition: { ease: "easeInOut" } },
  };
  return (
    <motion.section
      className="projects"
      variants={container}
      initial="first"
      animate="then"
      exit="last"
    >
      <PNav />
      <Latest />
      <AllProjects />
    </motion.section>
  );
};

export default Projects;
